import type { TFunction } from 'i18next'

export type SupportFaq = { q: string; a: string }

/** Keeps FAQ parsing out of `.tsx` so `ReturnType<...>['t']` cannot confuse the JSX parser. */
export function readSupportFaqs(t: TFunction): SupportFaq[] {
  const raw = t('support.faqs', { returnObjects: true })
  if (!Array.isArray(raw)) return []
  const out: SupportFaq[] = []
  for (const item of raw) {
    if (typeof item !== 'object' || item === null) continue
    const rec = item as Record<string, unknown>
    if (typeof rec.q === 'string' && typeof rec.a === 'string') {
      out.push({ q: rec.q, a: rec.a })
    }
  }
  return out
}
